import {Locales} from '@netx/core-next/locales/utils/Locales';
import {SearchSortOrder} from '@netx/core-search-rules';
import {SearchContext} from './constants';

export const SearchContextLabel = Locales((i18n) => ({
	[SearchContext.ADVANCED]: i18n('i18n.advancedSearch'),
	[SearchContext.ATTRIBUTE_HISTORY]: i18n('i18n.attributeHistory'),
	[SearchContext.KEYWORD]: i18n('i18n.keyword'),
	[SearchContext.AI]: i18n('i18n.ai'),
	[SearchContext.VIDEO_CLIP]: i18n('i18n.videoClips'),
	[SearchContext.VISUAL_ASSET]: i18n('i18n.asset'),
	[SearchContext.VISUAL_COLOR]: i18n('i18n.color'),

	[SearchContext.CATEGORY]: i18n('i18n.category'),
	[SearchContext.SAVED_SEARCH]: i18n('i18n.savedSearch'),
	[SearchContext.SAVED_CART]: i18n('i18n.savedCart'),
	[SearchContext.IDENTIFIED_PEOPLE]: i18n('i18n.people'),
}));

export const SearchContextToolTip = Locales((i18n) => ({
	[SearchContext.ADVANCED]: i18n('i18n.searchToolTip_advancedSearch'),
	[SearchContext.KEYWORD]: i18n('i18n.searchToolTip_keyword'),
	[SearchContext.AI]: i18n('i18n.searchToolTip_ai'),
	[SearchContext.ATTRIBUTE_HISTORY]: i18n(
		'i18n.searchToolTip_attributeHistory',
	),
	[SearchContext.IDENTIFIED_PEOPLE]: i18n('i18n.searchToolTip_people'),
	[SearchContext.VIDEO_CLIP]: i18n('i18n.searchToolTip_videoClips'),
	[SearchContext.VISUAL_ASSET]: i18n('i18n.searchToolTip_visualAsset'),
	[SearchContext.VISUAL_COLOR]: i18n('i18n.searchToolTip_visualColor'),
	[SearchContext.CATEGORY]: i18n('i18n.searchToolTip_category'),
	[SearchContext.SAVED_SEARCH]: i18n('i18n.searchToolTip_savedSearch'),
	[SearchContext.SAVED_CART]: i18n('i18n.searchToolTip_savedCart'),
}));

export const SearchSubHeaderLabel = Locales((i18n) => ({
	SEARCHING_FOR: i18n('i18n.lookingFor'),
	SEARCH_WITHIN: i18n('i18n.findIn'),
	SUGGESTIONS: i18n('i18n.suggestions'),
}));

export const SearchPlaceholderLabel = Locales((i18n) => ({
	DEFAULT: i18n('i18n.search'),
	COLOR: 'e.g. #000000',
	AI: i18n('i18n.aiSearchPlaceholder'),
}));

export const SearchActionLabel = Locales((i18n) => ({
	CLEAR: i18n('i18n.clear'),
}));

export const SearchSortLabel = Locales((i18n) => ({
	SORT: i18n('i18n.sort'),
}));

export const SearchSortFieldLabel = Locales((i18n) => ({}));

export const SearchSortOrderLabel = Locales((i18n) => ({
	[SearchSortOrder.ASC]: i18n('i18n.sortAscending'),
	[SearchSortOrder.DESC]: i18n('i18n.sortDescending'),
}));
